import { Instagram, Music2, Ghost, Facebook, Twitter, Youtube, MessageCircle, Globe } from "lucide-react";

const MAP = {
  instagram: Instagram,
  tiktok: Music2,
  snapchat: Ghost,
  facebook: Facebook,
  twitter: Twitter,
  x: Twitter,
  youtube: Youtube,
  whatsapp: MessageCircle,
};

export default function SocialIcon({ platform, className }) {
  const Icon = MAP[(platform || "").toLowerCase()] || Globe;
  return <Icon className={className} />;
}
